export const baseUrl = "https://back-ecommerce.ibdaa-booking.com/api";

export const loginURL = "login";

export const registerURL = "register";

export const categoriesURL = "/categories";

export const productsURL = "/products";

export const favoritesURL = "/favorites";

export const trainersURL = "trainers";

export const clientURL = "clients";

export const usersURL = "users";

export const permissionsURL = "permissions";

export const notificationsURL = "notifications";

export const statisticsURL = "statistics";

export const departmentsURL = "departments";

export const contactUsURL = "contact-us";

export const productRatesURL = "product-rates";

export const cartURL = "cart";

export const advertisementsURL = "advertisements";

export const toggleFavURL = "favorites/toggle";

export const storeInfoURL="store-info"

export const countriesURL="countries"

export const ordersURL="orders"

export const profileURL="profile"

export const checkURL="orders/check"
